import { Environment } from './environment.model';

// TODO: apiEndpoint/dns are placeholders until partner API hosts are confirmed.
export const environment: Environment = {
  production: false,
  apiEndpoint: 'https://partner-dashboard.api.test.romulus.live',
  dns: 'https://partner-dashboard.test.romulus.live',
  defaultLanguage: 'en',
  supportedLanguages: [
    { locale: 'it', name: 'Italiano' },
    { locale: 'en', name: 'English' },
  ],
};
